import { RadioInput, RadioOption } from 'shared/ui/controls';

export type GenderValue = 'male' | 'female';

const DEFAULT_GENDER_OPTIONS: RadioOption<GenderValue>[] = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' }
];

export interface GenderInputProps {
  value?: GenderValue;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: GenderValue) => void;
  name?: string;
  isSolid?: boolean;
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
}

export const GenderInput = ({ isSolid = true, size = 'md', ...props }: GenderInputProps) => {
  return <RadioInput<GenderValue> options={DEFAULT_GENDER_OPTIONS} isSolid={isSolid} size={size} {...props} />;
};
